// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3QXP8","svg":"styles_svg__2ZuDr"};